import { render, staticRenderFns } from "./ModalMovimentacaoEstoque.vue?vue&type=template&id=5068205c"
import script from "./ModalMovimentacaoEstoque.vue?vue&type=script&lang=js"
export * from "./ModalMovimentacaoEstoque.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports